import React, { createContext, useState, useContext } from 'react';

const FooterContext = createContext({
  showFooter: false,
  setShowFooter: () => {},
});

export const FooterProvider = ({ children }) => {
  const [showFooter, setShowFooter] = useState(false);

  return (
    <FooterContext.Provider value={{ showFooter, setShowFooter }}>
      {children}
    </FooterContext.Provider>
  );
};

export const useFooter = () => useContext(FooterContext);
